import type { ReactNode } from 'react';

export const symbol_image_inset: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M230-280h500q12 0 21-9t9-21v-340q0-12-9-21t-21-9H230q-12 0-21 9t-9 21v340q0 12 9 21t21 9Zm-90 120q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Zm210-180q-8.5 0-12.75-8t.75-16l55-73q5-6 12-6t12 6l43 57 63-84q5-6 12-6t12 6l75 100q5 8 .75 16T610-400H350Z"
		/>
	</svg>
);
